/**
 * /tracking/postback-api — operator page for feature FS-174 (Postback API).
 *
 * Declares a TanStack Router route and renders the `PostbackApiPage` feature.
 * Root wire-up picks this up from `router.tsx`.
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { PostbackApiPage } from "@/features/postback-api/PostbackApiPage";

export const trackingPostbackApiRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/postback-api",
	component: TrackingPostbackApiRoute,
});

export default trackingPostbackApiRoute;

export function TrackingPostbackApiRoute() {
	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-6xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">Postback API</li>
				</ol>
			</nav>

			<PostbackApiPage />
		</div>
	);
}

// Named export for the root wire-up cycle.
export { TrackingPostbackApiRoute as TrackingPostbackApiPage };
